import { render, staticRenderFns } from "./hydropower.vue?vue&type=template&id=a7af8358&scoped=true&"
import script from "./hydropower.vue?vue&type=script&lang=js&"
export * from "./hydropower.vue?vue&type=script&lang=js&"
import style0 from "./hydropower.vue?vue&type=style&index=0&id=a7af8358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7af8358",
  null
  
)

export default component.exports